import { IconButton, Icons, Box } from '@cast/design-system';

import { WhenMode, InputsStack, RffInput } from '@cast/shared-rff-ui';

type CustomLabelsStackProps = {
  disabled: boolean;
};

export const CustomLabelsStack = ({ disabled }: CustomLabelsStackProps) => (
  <InputsStack
    sx={{ '& .RffInputsArray-rows': { gap: 10, ml: 24 } }}
    name="_customLabels"
    addRowButtonTestId="custom-label-pair-add-button"
    renderInputsRow={({ index, remove, isOnly }) => {
      return (
        <Box display="grid" gridTemplateColumns="1fr 1fr 32px" columnGap={8}>
          <RffInput
            testId={`custom-label-pair-${index}-key-input`}
            disabled={disabled}
            name={`_customLabels[${index}].key`}
            label="Key"
            size="small"
            placeholder="e.g. createdby"
          />
          <RffInput
            testId={`custom-label-pair-${index}-value-input`}
            disabled={disabled}
            name={`_customLabels[${index}].value`}
            label="Value"
            size="small"
            placeholder="e.g. marius"
          />
          {!isOnly && (
            <WhenMode mode={['edit', 'create']}>
              <IconButton
                testId={`custom-label-pair-${index}-delete-button`}
                variant="ghost"
                onClick={() => remove()}
                size="sm"
                sx={{ alignSelf: 'flex-end' }}
              >
                <Icons.X />
              </IconButton>
            </WhenMode>
          )}
        </Box>
      );
    }}
  />
);
